import React, { useState, useEffect } from "react";
import jsPDF from "jspdf";
import "jspdf-autotable";
import ApiRequest from "../../../utils/ApiRequest";
import ExportToolbarButton from "./ExportToolbarButton";

/**
 * PDF export via ApiRequest (legacy APIs returning metaInfo.data). V2-styled button only.
 * Props align with V1 `components/ExportFiles/PdfDownApi.js`.
 */
export default function PdfDownApi({
  tableHeader,
  getTableBody,
  url,
  params,
  heading = "",
  fileName = "Report",
  width = 800,
  method = "post",
  digit = 0,
}) {
  const [data, setData] = useState([]);
  const [isDisabled, setIsDisabled] = useState(false);
  const [triggerDownload, setTriggerDownload] = useState(false);

  useEffect(() => {
    if (triggerDownload && data.length > 0) {
      const tableBody = getTableBody(data);
      generatePDF(tableBody);
      setTriggerDownload(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- getTableBody intentionally fresh per download
  }, [triggerDownload, data]);

  const downloadReport = () => {
    if (isDisabled) return;
    setIsDisabled(true);
    fetchData();
    setTimeout(() => setIsDisabled(false), 15000);
  };

  const fetchData = () => {
    const successHandler = (res) => {
      let contentData = method === "get" ? res?.data?.metaInfo?.data || [] : res?.data?.metaInfo?.data || [];

      if (digit === 1) {
        contentData = contentData.map((value) => ({
          ...value,
          transactionId: " txn_ " + value.transactionId,
        }));
      }

      setData(contentData);
      setTriggerDownload(true);
    };

    const errorHandler = () => {};

    const api = new ApiRequest("", successHandler, errorHandler, false);
    if (method === "post") {
      api.post(url, params);
    } else {
      api.get(url);
    }
  };

  const generatePDF = (tableBody) => {
    const doc = new jsPDF("l", "px", [width, 600]);

    if (heading) {
      doc.text(heading, doc.internal.pageSize.width / 2, 20, { align: "center" });
    }

    doc.autoTable({
      head: tableHeader,
      body: tableBody,
      startY: 30,
      styles: { overflow: "linebreak", cellWidth: "wrap" },
      columnStyles: { text: { cellWidth: "auto" } },
    });

    doc.save(`${fileName || "document"}.pdf`);
  };

  return (
    <ExportToolbarButton loading={isDisabled} onClick={downloadReport}>
      PDF
    </ExportToolbarButton>
  );
}
